import type {APITask} from '@github-ui/agent-sessions/types/api-task'
import {DOTCOM_CHAT_AGENT_SLUG} from '@github-ui/agent-sessions/utils/constants'
import {isQuickChatTaskViewEnabled as isAgentSessionsQuickChatTaskViewEnabled} from '@github-ui/agent-sessions/utils/is-quick-chat-task'
import {
  provisionalTaskTitle,
  shouldUseProvisionalTaskTitle,
  taskTitleDuringProvisioning,
} from '@github-ui/agent-sessions/utils/task-helpers'

export function provisionalQuickChatTitle(prompt: string): string {
  return provisionalTaskTitle(prompt)
}

export function shouldUseProvisionalQuickChatTitle(title: string | undefined): boolean {
  return shouldUseProvisionalTaskTitle(title)
}

export function quickChatTaskTitleDuringProvisioning(
  title: string | undefined,
  prompt: string | undefined,
): string | undefined {
  return taskTitleDuringProvisioning(title, prompt)
}

export function isQuickChatTaskViewEnabled(): boolean {
  return isAgentSessionsQuickChatTaskViewEnabled()
}

/**
 * Direct task URLs bypass the filtered listing APIs, so reject every task with
 * the authoritative frontend-visible Dotcom Chat identity.
 */
export function isLegacyQuickChatTask(
  task: (Pick<APITask, 'agent_collaborators'> & {isOptimistic?: boolean}) | null | undefined,
): boolean {
  return (
    !task?.isOptimistic &&
    task?.agent_collaborators?.some(collaborator => collaborator.slug === DOTCOM_CHAT_AGENT_SLUG) === true
  )
}
